import es from './es.json'
import es_mx from './es_mx.json'
import es_cl from './es_cl.json'
import es_co from './es_co.json'
import en from './en.json'
import fr from './fr.json'
import it from './it.json'
import de from './de.json'
import pt from './pt.json'
import nl from './nl.json'


export const languages = {
	'es': es,
	'es-mx': es_mx,
	'es-cl': es_cl,
	'es-co': es_co,
  	'en': en,
	'en-au': en,
	'de': de,
    'de-ch': de,
	'fr-ch': fr,
	'it-ch': it,
	'fr': fr,
	'it': it,
	'pt': pt,
	'nl': nl,
	'pl': en,
	'ru': en,
	'int': en

}